import { Injectable } from '@angular/core';

import {
  BaseWsService,
  DialogErrorService,
  ParsedWebsocketMessage,
  ResourcesService,
  ToastService,
  WebsocketMessageService,
} from '@mitsubishi/core';
import { ErrorDialogData } from '@mitsubishi/shared/data-access';
import { RequestTraceCommonMessages } from '@mitsubishi/shared/request-tracing';
import { SpinnerService } from '@mitsubishi/ui/spinner';

import { UnitConfigurationFacade } from '../../state/unit-configuration/unit-configuration.facade';
import { UNIT_TOPIC, UnitMessages } from './unit.messages';

@Injectable({
  providedIn: 'root',
})
export class UnitWsService extends BaseWsService {
  constructor(
    wsMessageService: WebsocketMessageService,
    serverResourceService: ResourcesService,
    toastService: ToastService,
    private spinnerService: SpinnerService,
    private dialogErrorService: DialogErrorService,
    private unitConfigurationFacade: UnitConfigurationFacade
  ) {
    super(wsMessageService, serverResourceService, toastService);
  }

  subscribeTopic(payload: any) {
    super.subscribeTopic(payload);
  }

  setTopic(unitId: string) {
    this.topic = `${UNIT_TOPIC}/${unitId}`;
  }

  protected get excludedMessagesFromLog(): string[] {
    return [UnitMessages.DeclaroUnitUpdateMessage, UnitMessages.ExternalUnitsReadyMessage];
  }

  handleMessage(message: ParsedWebsocketMessage) {
    super.handleMessage(message);

    const payload = message.payload;
    switch (message.description) {
      case UnitMessages.DeclaroUnitUpdateMessage:
        this.unitConfigurationFacade.setUpdatingAccessories(payload.updating);
        break;
      case UnitMessages.ExternalUnitsReadyMessage:
        this.unitConfigurationFacade.setExternalUnits(payload);
        break;
      case RequestTraceCommonMessages.RequestCompletedMessage:
        this.spinnerService.hideMainSpinner();
        this.unitConfigurationFacade.resetExternalUnitsState();
        this.dialogErrorService.setDialogError({
          message: payload,
        } as ErrorDialogData);
    }
  }
}
